import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  Edit,
  FormTab,
  FunctionField,
  List,
  NumberField,
  NumberInput,
  required,
  SearchInput,
  SelectInput,
  TextField,
} from "react-admin";
import { EMOTION_LEVELS, EMOTION_TYPES } from "../constants/emotions";
import { useCommonLabels } from "../i18n/hooks";
import { FilePreviewLink } from "../ui/fileUpload";
import { FormSection } from "../ui/forms/FormSection";
import { PhraseLangFields } from "../ui/forms/langFields";
import { LangTabbedForm } from "../ui/forms/LangTabbedForm";
import { LocalizedFileControls, LocalizedFileLangField } from "../ui/forms/LocalizedFileInput";
import { HexColorInput, ColorSwatch } from "../ui/forms/HexColorInput";
import CoverTextColorField from "../ui/forms/CoverTextColorField";
import PhraseCardPreview from "../ui/forms/PhraseCardPreview";
import { normalizePhraseRecord } from "../ui/forms/normalizeMedia";

const filters = [
  <SearchInput key="q" source="q" alwaysOn />,
  <SelectInput key="type" source="Type" choices={EMOTION_TYPES} />,
  <SelectInput key="level" source="Level" choices={EMOTION_LEVELS} />,
];

const PhPhraseForm = () => {
  const c = useCommonLabels();
  return (
    <LangTabbedForm>
      <FormTab label="Общее">
        <FormSection title="Классификация">
          <SelectInput source="Type" label={c.type} choices={EMOTION_TYPES} validate={required()} fullWidth />
          <NumberInput source="Level" label={c.level} min={1} max={3} validate={required()} fullWidth />
          <BooleanInput source="Active" label={c.active} defaultValue />
        </FormSection>
        <FormSection title="Фон карточки">
          <LocalizedFileControls
            baseSource="Background"
            label={c.background}
            kind="image"
            helperText="JPG/PNG — фон слайдера на главном экране"
          />
          <CoverTextColorField />
          <PhraseCardPreview />
        </FormSection>
      </FormTab>
      <FormTab label="🇦🇿 AZ">
        <PhraseLangFields lang="AZ" phraseRequired />
        <LocalizedFileLangField baseSource="Background" lang="AZ" label={c.background} kind="image" />
      </FormTab>
      <FormTab label="🇷🇺 RU">
        <PhraseLangFields lang="RU" phraseRequired />
        <LocalizedFileLangField baseSource="Background" lang="RU" label={c.background} kind="image" />
      </FormTab>
      <FormTab label="🇬🇧 EN">
        <PhraseLangFields lang="EN" phraseRequired />
        <LocalizedFileLangField baseSource="Background" lang="EN" label={c.background} kind="image" />
      </FormTab>
    </LangTabbedForm>
  );
};

export const PhPhraseList = () => {
  const c = useCommonLabels();
  return (
    <List filters={filters} sort={{ field: "Id", order: "DESC" }}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="Id" label="ID" />
        <TextField source="PhraseRU" label={c.phrase} />
        <FunctionField
          label={c.background}
          render={(record: { Background?: string; BackgroundRU?: string }) => (
            <FilePreviewLink value={record.BackgroundRU || record.Background} />
          )}
        />
        <FunctionField
          label={c.textColor}
          render={(record: { TextColor?: string }) => <ColorSwatch value={record.TextColor} />}
        />
        <TextField source="Type" label={c.type} />
        <NumberField source="Level" label={c.level} />
        <BooleanField source="Active" label={c.status} />
      </Datagrid>
    </List>
  );
};

export const PhPhraseEdit = () => (
  <Edit mutationMode="pessimistic" transform={normalizePhraseRecord}>
    <PhPhraseForm />
  </Edit>
);

export const PhPhraseCreate = () => (
  <Create transform={normalizePhraseRecord}>
    <PhPhraseForm />
  </Create>
);
